'use strict';

wbApp.controller('CoursesLeadsCtrl', ['$scope', '$modal', '$q', '$translate', '$filter', 'leadSvc', 'courseSvc', 'gridSortSvc',
    'securitySvc', 'courseRegistrationSvc',
function ($scope, $modal, $q, $translate, $filter, leadSvc, courseSvc, gridSortSvc, securitySvc, courseRegistrationSvc) {

    $scope.selectedCourse = null;
    var isActive = false;
    var loaded = false;
    $scope.courseLeads = [];
    
    $scope.$on('selectedCourseChanged', function (e, courseInd) {
        if (courseInd.course) {
            if (isActive) {
                if ($scope.selectedCourse !== courseInd.course || courseInd.refresh) {
                    $scope.courseLeads = leadSvc.getAllByStatusAndCourse(0 /* Open */, courseInd.course.courseID);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.courseLeads = [];
        }
        $scope.selectedCourse = courseInd.course;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 4) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.selectedCourse) {
                    $scope.courseLeads = leadSvc.getAllByStatusAndCourse(0 /* Open */, $scope.selectedCourse.courseID);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.courseLeadsGridSettings = {
        name: 'courseLeads',
        columns: [
            {
                dataField: 'id',
                caption: $translate.instant('TXT_LBL_ID'),
                dataType: 'string',
                visible: false,
                showInColumnChooser: false
            },
            {
                dataField: 'userFullName',
                caption: $translate.instant('TXT_LBL_USER'),
                dataType: 'string',
                width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'userFullName') }
            },
            {
                dataField: 'studentsFullName',
                caption: $translate.instant('TXT_LBL_STUDENT'),
                dataType: 'string',                
                sortOrder: 'asc',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentsFullName') }
            },
            {
                dataField: 'studentBirthday',
                caption: $translate.instant("TXT_LAB_BIRTHDAY"),
                dataType: 'date',
                format: { date: 'short' },
                width: '90px',
            },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '120px'
            },
            { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '190px' },

            {
                dataField: 'createdAtUtc',
                caption: $translate.instant('TXT_LBL_CREATED_AT'),
                dataType: 'date',
                format: { date: 'short' },
                width: '80px'
            },
        ],
        customCommands: [{
            text: $translate.instant('TXT_MENU_REGISTER_ON_COURSE'),
            isVisible: function (row) { return securitySvc.isInRole('Leads.Update') && securitySvc.isInRole('CourseRegistration.Insert'); },
            callback: function (row) { createCourseRegistrations(row); }
        },{
            text: $translate.instant('TXT_CHANGE_STATE'),
            isVisible: function (data) { return securitySvc.isInRole('Leads.Update'); },
            callback: function (data) { $scope.onChangeStatus(data); }
        }]
    }

    function createCourseRegistrations(model) {
        leadSvc.getById(model.id).$promise.then(function (lead) {

            var course = $scope.selectedCourse;

            if (lead.status == 1) {
                $scope.detailError = { errors: [{ message: $translate.instant('TXT_ERROR_LEAD_ALREADY_CONVERTED') }] };
            }
            else {
                $q.all([detailDialogPromise.$promise, courseRegistrationSvc.createNew(course, false)])
                .then(function (data) {
                    var courseRegistration = data[1];
                    if (!!lead.studentIds && lead.studentIds.length > 0) {
                        courseRegistration.studentID = lead.studentIds[0];
                    }

                    detailDialogPromise.$scope.course = course;
                    detailDialogPromise.$scope.model = courseRegistration;
                    // Do not search for leads during course registration save
                    detailDialogPromise.$scope.ignoreLeadAssignment = true; 
                    detailDialogPromise.$scope.onAfterSuccessSave = function (cr) {

                        lead.conversionType = 1; // CourseRegistraction
                        lead.conversionReferenceId = cr.courseRegistrationID;
                        lead.conversionDateUtc = moment().toDate();

                        var courseFullName = $filter('courseFullName')(course);
                        var firstLesson = !!course.firstLesson
                            ? ' (' + $filter('date')(course.firstLesson, 'EEE HH:mm').toUpperCase() + ')'
                            : '';
                        lead.conversionText = courseFullName + firstLesson;
                        lead.status = 1; // Converted

                        if (!lead.notes || lead.notes.length == 0) {
                            lead.notes = [];
                        }

                        var user = securitySvc.loggedInUser();

                        lead.notes.push({
                            text: $translate.instant('TXT_TITLE_REGISTER_ON_COURSE') + ': ' + lead.conversionText,
                            updatedAtUtc: moment().toDate(),
                            updatedByUserId: user.userID + "",
                            updatedByName: user.fullName
                        });

                        leadSvc.update(lead).$promise.then(function () {
                            $scope.courseLeads = leadSvc.getAllByStatusAndCourse(0 /* Open */, $scope.selectedCourse.courseID);
                        });
                    };
                    detailDialogPromise.show();
                })
            }
        })
    }

    $scope.onChangeStatus = function (lead) {
        leadsNoteDetailPromise.$promise.then(function () {
            leadsNoteDetailPromise.$scope.leadId = lead.id;
            leadsNoteDetailPromise.$scope.noteId = null;
            leadsNoteDetailPromise.$scope.onLeadSave = function (model) {
                $scope.courseLeads = leadSvc.getAllByStatusAndCourse(0 /* Open */, $scope.selectedCourse.courseID);
            };
            leadsNoteDetailPromise.show();
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'courses/courses/courses-detail-tabs/students-detail.html',
        show: false,        
        scope: $scope.$new()
    });

    var leadsNoteDetailPromise = $modal({
        templateUrl: 'leads/leads-detail-tabs/crm-notes-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
